/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'fabric.emoji.add.custom.emoji.label': 'Добавить собственный эмодзи',
  'fabric.emoji.add.label': 'Добавить эмодзи',
  'fabric.emoji.cancel.label': 'Отменить',
  'fabric.emoji.categories.label': 'Выберите категорию эмодзи',
  'fabric.emoji.categories.search.results': 'Результаты поиска',
  'fabric.emoji.category.activity': 'Занятия',
  'fabric.emoji.category.all.uploads': 'Все загруженные эмодзи',
  'fabric.emoji.category.flags': 'Флаги',
  'fabric.emoji.category.foods': 'Еда и напитки',
  'fabric.emoji.category.frequent': 'Популярные',
  'fabric.emoji.category.nature': 'Природа',
  'fabric.emoji.category.objects': 'Объекты',
  'fabric.emoji.category.people': 'Люди',
  'fabric.emoji.category.places': 'Места и путешествия',
  'fabric.emoji.category.productivity': 'Эффективность',
  'fabric.emoji.category.symbols': 'Символы',
  'fabric.emoji.category.user.uploads': 'Ваши эмодзи',
  'fabric.emoji.choose.file.screenReaderDescription':
    'Выберите файл с эмодзи в формате JPG, PNG или GIF размером не более 1 МБ',
  'fabric.emoji.choose.file.title': 'Выберите файл',
  'fabric.emoji.delete.description':
    'Вместо всех существующих экземпляров этого эмодзи будет использоваться {emojiShortName}',
  'fabric.emoji.delete.label': 'Удалить',
  'fabric.emoji.delete.screenreader.tooltip': 'Чтобы удалить эмодзи {shortName}, нажмите клавишу Backspace',
  'fabric.emoji.delete.title': 'Удаление эмодзи',
  'fabric.emoji.delete.tooltip': 'Удалить',
  'fabric.emoji.emojipicker.emoi.roledescription': 'кнопка эмодзи',
  'fabric.emoji.emojipicker.error': 'Ошибка!',
  'fabric.emoji.error.delete.failed': 'Не удалось удалить эмодзи',
  'fabric.emoji.error.image.too.big': 'Размер выбранного изображения превышает 1 МБ',
  'fabric.emoji.error.invalid.image': 'Выбрано недопустимое изображение',
  'fabric.emoji.error.upload.failed': 'Не удалось загрузить эмодзи',
  'fabric.emoji.error.upload.timeout': 'Время ожидания загрузки истекло',
  'fabric.emoji.image.requirements': 'JPG, PNG или GIF. Макс. размер: 1 МБ.',
  'fabric.emoji.name.ariaLabel': 'Введите название для нового эмодзи',
  'fabric.emoji.picker': 'Средство выбора эмодзи',
  'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {Поиск результатов} other {Эмодзи}}',
  'fabric.emoji.pickerlist.tabpanel': 'Панель с действиями и списком эмодзи',
  'fabric.emoji.placeholder': 'Например, «привет»',
  'fabric.emoji.preview': 'Новый эмодзи {emoji} очень классный!',
  'fabric.emoji.preview.title': 'Предпросмотр',
  'fabric.emoji.retry.label': 'Повторить попытку',
  'fabric.emoji.search.label': 'Название эмодзи',
  'fabric.emoji.search.placeholder': 'Поиск',
  'fabric.emoji.search.status': 'Просмотр всех эмодзи',
  'fabric.emoji.select.skin.list.ariaLabel': 'Селектор цвета кожи',
  'fabric.emoji.select.skin.tone.ariaLabel': 'Выберите свой цвет кожи, выбрано: {selectedTone}',
};
